import type { Editor } from '@tiptap/core';

/** The scroll-to highlight is a real `highlight` mark in the document, so cleanForSave strips it by this class. */
export const PULSE_HIGHLIGHT_CLASS = 'pulse-highlight';

export const clearPulseHighlights = (editor: Editor, className: string) => {
  const tr = editor.view.state.tr;
  const { highlight: hlMark } = editor.schema.marks;

  editor.view.state.doc.descendants((node, pos) => {
    if (!node.isText || !node.marks.length) return;

    node.marks.forEach((mark) => {
      if (mark.type === hlMark && mark.attrs.class === className) {
        tr.removeMark(pos, pos + node.nodeSize, mark);
      }
    });
  });

  return tr;
};
